// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell-row {
  display: flex;
  flex-direction: row;
}

.cell {
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.selected {
  background-color: #e0f7fa;
}

.in-progress {
  background-color: #fdd835;
}

.end-shift {
  background-color: #4caf50;
}

.cell-text {
  font-size: 14px;
  text-align: center;
}

.in-progress-text {
  font-weight: bold;
  color: #000;
}

.end-shift-text {
  font-weight: bold;
  color: #fff;
}
.cell-row {
  display: flex;
  flex-direction: row;
}



.highlighted {
  outline: 2px solid #1976d2;
}

.selected {
  background-color: #e3f2fd;
}

.in-progress {
  background-color: #fff176;
}

.end-shift {
  background-color: #81c784;
}

.cell-text,
.in-progress-text,
.end-shift-text {
  font-size: 13px;
  text-align: center;
}

.in-progress-text {
  font-weight: bold;
  color: #333;
}

.end-shift-text {
  font-weight: bold;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/roster/Roster.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;;;AAIA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd","sourcesContent":[".cell-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.cell {\n  border: 1px solid #ccc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.selected {\n  background-color: #e0f7fa;\n}\n\n.in-progress {\n  background-color: #fdd835;\n}\n\n.end-shift {\n  background-color: #4caf50;\n}\n\n.cell-text {\n  font-size: 14px;\n  text-align: center;\n}\n\n.in-progress-text {\n  font-weight: bold;\n  color: #000;\n}\n\n.end-shift-text {\n  font-weight: bold;\n  color: #fff;\n}\n.cell-row {\n  display: flex;\n  flex-direction: row;\n}\n\n\n\n.highlighted {\n  outline: 2px solid #1976d2;\n}\n\n.selected {\n  background-color: #e3f2fd;\n}\n\n.in-progress {\n  background-color: #fff176;\n}\n\n.end-shift {\n  background-color: #81c784;\n}\n\n.cell-text,\n.in-progress-text,\n.end-shift-text {\n  font-size: 13px;\n  text-align: center;\n}\n\n.in-progress-text {\n  font-weight: bold;\n  color: #333;\n}\n\n.end-shift-text {\n  font-weight: bold;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
